<app-dialog-wrapper [isClosing]="isClosing" (animationend)="onAnimationEnd()">
  <div class="w-full p-2 flex-1">
    <h2 [ngClass]="data.isError ? 'text-red-600' : 'text-green-600' " class="text-lg font-bold mb-4">
      {{ data.title }}
    </h2>

    <p class="text-sm text-gray-600 mb-4">
      {{ data.message }}
    </p>

    <button (click)="onClose()" class="bg-white w-full font-bold text-lg py-4 shadow-md rounded-full">Fermer</button>
  </div>
</app-dialog-wrapper>